import { num } from "@/lib/api";

export function DimensionPreview({ width, height }) {
  const w = Number(width) || 0;
  const h = Number(height) || 0;
  const max = Math.max(w, h, 0.01);
  const bw = w > 0 ? Math.max(20, (w / max) * 200) : 0;
  const bh = h > 0 ? Math.max(20, (h / max) * 140) : 0;
  const x = 50 + (200 - bw) / 2;
  const y = 20 + (140 - bh) / 2;

  return (
    <div className="grain rounded-md border border-dashed border-slate-300 bg-slate-50 p-3" data-testid="dimension-preview">
      <svg viewBox="0 0 280 190" className="h-40 w-full">
        {w > 0 && h > 0 ? (
          <>
            <rect x={x} y={y} width={bw} height={bh} fill="#0099DD" fillOpacity="0.12" stroke="#0099DD" strokeWidth="2" rx="2" style={{ transition: "all .3s" }} />
            <line x1={x} y1={y + bh + 12} x2={x + bw} y2={y + bh + 12} stroke="#E5007D" strokeWidth="1.5" />
            <text x={x + bw / 2} y={y + bh + 26} textAnchor="middle" fontSize="11" fill="#475569" fontFamily="JetBrains Mono, monospace" data-testid="preview-width-label">{num(w, 1)} cm</text>
            <line x1={x - 12} y1={y} x2={x - 12} y2={y + bh} stroke="#E5007D" strokeWidth="1.5" />
            <text x={x - 16} y={y + bh / 2} textAnchor="middle" dominantBaseline="middle" fontSize="11" fill="#475569" fontFamily="JetBrains Mono, monospace" transform={`rotate(-90 ${x - 16} ${y + bh / 2})`} data-testid="preview-height-label">{num(h, 1)} cm</text>
          </>
        ) : (
          <text x="140" y="95" textAnchor="middle" fontSize="12" fill="#94a3b8">Informe as medidas</text>
        )}
      </svg>
    </div>
  );
}
